import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit/src/createAction";
import _get from "lodash/get";
import _has from "lodash/has";
import type { RootState } from "../store";
import { HYDRATE } from "./constants";

export type RecursiveKeyOf<TObj extends object> = {
  [TKey in keyof TObj & (string | number)]: TObj[TKey] extends any[]
    ? `${TKey}`
    : TObj[TKey] extends object
      ? `${TKey}` | `${TKey}.${RecursiveKeyOf<TObj[TKey]>}`
      : `${TKey}`;
}[keyof TObj & (string | number)];

/**
 * Нужно для того что бы серверный и клиентский стор корректно гидрировались
 * @param builder
 * @param path string ключ RootState объекта
 * @example addHydrateReducer(builder, "pages.personalCabinet.paymentsHistory")
 */
export function addHydrateReducer<T>(
  builder: ActionReducerMapBuilder<T>,
  path: RecursiveKeyOf<RootState>
): ActionReducerMapBuilder<T> {
  return builder.addCase(
    HYDRATE as string,
    (state, action: PayloadAction<RootState>) => {
      if (_has(action.payload, path)) {
        return {
          ...state,
          ..._get(action.payload, path),
        };
      }
    }
  );
}
